module.exports = __webpack_public_path__ + "static/media/icon_59.af24b51f.svg";